@file:OptIn(InternalResourceApi::class)

package de.connect2x.timmy.timaokwebclient.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/de.connect2x.timmy.timaokwebclient.generated.resources/"

@delegate:ResourceContentHash(-231_951_361)
internal val Res.font.AOKBuenosAires_Bold: FontResource by lazy {
      FontResource("font:AOKBuenosAires_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/AOKBuenosAires-Bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_489_212_564)
internal val Res.font.AOKBuenosAires_BoldItalic: FontResource by lazy {
      FontResource("font:AOKBuenosAires_BoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/AOKBuenosAires-BoldItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-825_066_121)
internal val Res.font.AOKBuenosAires_Regular: FontResource by lazy {
      FontResource("font:AOKBuenosAires_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/AOKBuenosAires-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(892_927_177)
internal val Res.font.AOKBuenosAires_RegularItalic: FontResource by lazy {
      FontResource("font:AOKBuenosAires_RegularItalic", setOf(
        ResourceItem(setOf(), "${MD}font/AOKBuenosAires-RegularItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_179_698_714)
internal val Res.font.AOKBuenosAires_SemiBold: FontResource by lazy {
      FontResource("font:AOKBuenosAires_SemiBold", setOf(
        ResourceItem(setOf(), "${MD}font/AOKBuenosAires-SemiBold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(591_774_009)
internal val Res.font.AOKBuenosAires_SemiBoldItalic: FontResource by lazy {
      FontResource("font:AOKBuenosAires_SemiBoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/AOKBuenosAires-SemiBoldItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_123_666_770)
internal val Res.font.Lato_Black: FontResource by lazy {
      FontResource("font:Lato_Black", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-Black.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_640_585_993)
internal val Res.font.Lato_BlackItalic: FontResource by lazy {
      FontResource("font:Lato_BlackItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-BlackItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_890_037_422)
internal val Res.font.Lato_Bold: FontResource by lazy {
      FontResource("font:Lato_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-Bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-624_617_106)
internal val Res.font.Lato_BoldItalic: FontResource by lazy {
      FontResource("font:Lato_BoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-BoldItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_064_597_202)
internal val Res.font.Lato_Italic: FontResource by lazy {
      FontResource("font:Lato_Italic", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-Italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(299_103_463)
internal val Res.font.Lato_Light: FontResource by lazy {
      FontResource("font:Lato_Light", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-Light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_830_055_221)
internal val Res.font.Lato_LightItalic: FontResource by lazy {
      FontResource("font:Lato_LightItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-LightItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_807_388_209)
internal val Res.font.Lato_Regular: FontResource by lazy {
      FontResource("font:Lato_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-914_005_101)
internal val Res.font.Lato_Thin: FontResource by lazy {
      FontResource("font:Lato_Thin", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-Thin.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_032_218_073)
internal val Res.font.Lato_ThinItalic: FontResource by lazy {
      FontResource("font:Lato_ThinItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Lato-ThinItalic.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("AOKBuenosAires_Bold", Res.font.AOKBuenosAires_Bold)
  map.put("AOKBuenosAires_BoldItalic", Res.font.AOKBuenosAires_BoldItalic)
  map.put("AOKBuenosAires_Regular", Res.font.AOKBuenosAires_Regular)
  map.put("AOKBuenosAires_RegularItalic", Res.font.AOKBuenosAires_RegularItalic)
  map.put("AOKBuenosAires_SemiBold", Res.font.AOKBuenosAires_SemiBold)
  map.put("AOKBuenosAires_SemiBoldItalic", Res.font.AOKBuenosAires_SemiBoldItalic)
  map.put("Lato_Black", Res.font.Lato_Black)
  map.put("Lato_BlackItalic", Res.font.Lato_BlackItalic)
  map.put("Lato_Bold", Res.font.Lato_Bold)
  map.put("Lato_BoldItalic", Res.font.Lato_BoldItalic)
  map.put("Lato_Italic", Res.font.Lato_Italic)
  map.put("Lato_Light", Res.font.Lato_Light)
  map.put("Lato_LightItalic", Res.font.Lato_LightItalic)
  map.put("Lato_Regular", Res.font.Lato_Regular)
  map.put("Lato_Thin", Res.font.Lato_Thin)
  map.put("Lato_ThinItalic", Res.font.Lato_ThinItalic)
}
